// Common timezones organized by region for dropdown selection
export const TIMEZONES = [
  // Europe (5 timezones)
  { value: "Europe/London", label: "Europe - London (GMT)" },
  { value: "Europe/Paris", label: "Europe - Paris (CET)" },
  { value: "Europe/Berlin", label: "Europe - Berlin (CET)" },
  { value: "Europe/Madrid", label: "Europe - Madrid (CET)" },
  { value: "Europe/Moscow", label: "Europe - Moscow (MSK)" },
  
  // North America (5 timezones)
  { value: "America/New_York", label: "North America - New York (EST)" },
  { value: "America/Chicago", label: "North America - Chicago (CST)" },
  { value: "America/Denver", label: "North America - Denver (MST)" },
  { value: "America/Los_Angeles", label: "North America - Los Angeles (PST)" },
  { value: "America/Toronto", label: "North America - Toronto (EST)" },
  
  // Asia (5 timezones)
  { value: "Asia/Dubai", label: "Asia - Dubai (GST)" },
  { value: "Asia/Shanghai", label: "Asia - Shanghai (CST)" },
  { value: "Asia/Tokyo", label: "Asia - Tokyo (JST)" },
  { value: "Asia/Singapore", label: "Asia - Singapore (SGT)" },
  { value: "Asia/Mumbai", label: "Asia - Mumbai (IST)" },
  
  // Africa (5 timezones)
  { value: "Africa/Cairo", label: "Africa - Cairo (EET)" },
  { value: "Africa/Johannesburg", label: "Africa - Johannesburg (SAST)" },
  { value: "Africa/Lagos", label: "Africa - Lagos (WAT)" },
  { value: "Africa/Casablanca", label: "Africa - Casablanca (WET)" },
  { value: "Africa/Nairobi", label: "Africa - Nairobi (EAT)" },
  
  // Oceania (2 timezones)
  { value: "Australia/Sydney", label: "Oceania - Sydney (AEDT)" },
  { value: "Pacific/Auckland", label: "Oceania - Auckland (NZDT)" },
  
  // South America (2 timezones)
  { value: "America/Sao_Paulo", label: "South America - São Paulo (BRT)" },
  { value: "America/Buenos_Aires", label: "South America - Buenos Aires (ART)" },
];

/**
 * Get the default timezone (auto-detected from browser)
 */
export const getDefaultTimezone = () => {
  if (typeof window !== "undefined") {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {
      console.warn("Could not detect timezone:", error);
    }
  }
  return "UTC";
};

/**
 * Find timezone in the list or return default
 */
export const findTimezone = (timezone) => {
  if (!timezone) return getDefaultTimezone();
  const found = TIMEZONES.find(tz => tz.value === timezone);
  return found ? found.value : timezone; // Return original if not in list
};

/**
 * Get timezone label for display
 */
export const getTimezoneLabel = (timezone) => {
  if (!timezone) return "Select timezone";
  const found = TIMEZONES.find(tz => tz.value === timezone);
  return found ? found.label : timezone;
};

